import React, { useEffect, useState } from "react";
import clsx from "clsx";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogContent } from "@mui/material";
import { Card, Typography } from "@curves/ui-base";
import {
	ConsumerSectionByRead,
	InvoiceSectionByRead,
	OrderEffectStateSectionByRead,
	PaymentSectionByRead,
	ProductSectionByRead,
	TerminateSectionByRead,
	ReceiverSectionByRead,
	ResumeSectionByRead,
	ShippingSectionByRead,
	SuspensionSectionByRead,
} from "@icoach/healthyCyclePurchase/components";
import useCyclePurchaseEffectApi from "@apis/useCyclePurchaseEffectApi";
import { isEmpty, isEqual } from "@util/utils";
import { EFFECT_CONTENT_TYPE } from "@constants/";

const _effectTypeMap = new Map([
	[EFFECT_CONTENT_TYPE.ITEMS, ProductSectionByRead],
	[EFFECT_CONTENT_TYPE.CHANGEITEMS, ProductSectionByRead],
	[EFFECT_CONTENT_TYPE.SHIPPINGDAY, ShippingSectionByRead],
	[EFFECT_CONTENT_TYPE.RECEIVER, ReceiverSectionByRead],
	[EFFECT_CONTENT_TYPE.PAYMENT, PaymentSectionByRead],
	[EFFECT_CONTENT_TYPE.INVOICE, InvoiceSectionByRead],
	[EFFECT_CONTENT_TYPE.STOP, SuspensionSectionByRead],
	[EFFECT_CONTENT_TYPE.QUIT, TerminateSectionByRead],
	[EFFECT_CONTENT_TYPE.RESTOP, ResumeSectionByRead],
]);

const CyclePurchaseEffectDialog = ({ className, open, sourceData: sourceDataProps, onClose }) => {
	const { cycleOrderID, effectID } = sourceDataProps || {};
	const { getCyclePurchaseEffectOrderApi } = useCyclePurchaseEffectApi();
	const [sourceData, setSourceData] = useState({});
	const doCyclePurchaseEffectOrderApi = async (cycleOrderID, effectID) => {
		let res = await getCyclePurchaseEffectOrderApi(cycleOrderID, effectID);
		if (res) {
			setSourceData(res);
		}
	};

	useEffect(
		() => {
			if (open) {
				doCyclePurchaseEffectOrderApi(cycleOrderID, effectID);
			}
		},
		// eslint-disable-next-line
		[open],
	);
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-90rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>健康產品變更單</GradientColorHeader>
			<DialogContent>
				<Card className={"order-info-card mb-4"}>
					<ConsumerSectionByRead sourceData={sourceData} />
					<OrderEffectStateSectionByRead sourceData={sourceData} />
				</Card>
				<Typography className={"font-weight-bold mb-1"} variant={"h5"}>
					變動的項目
				</Typography>
				<Card className={"order-info-card mb-4"}>
					{!isEmpty(sourceData?.effectType) &&
						sourceData?.effectType.map(type => {
							let Component = _effectTypeMap.get(type);
							// 防呆：後端若回傳前端尚未對應的變更類型，略過該區塊而非讓整個 dialog 崩潰
							if (!Component) return null;

							return <Component key={type} sourceData={sourceData} isShowNoDeductNow={isEqual(EFFECT_CONTENT_TYPE.PAYMENT, type)} />;
						})}
				</Card>
			</DialogContent>
		</Dialog>
	);
};

export default CyclePurchaseEffectDialog;
